// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._19pkx0bf{margin-top:var(--ds-space-negative-100,-8px)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1o9zkb7n{flex-shrink:1}\n._2hwx12x7{margin-right:var(--ds-space-075,6px)}\n._2hwx1f3t{margin-right:var(--ds-space-100,.5em)}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._i0dlf1ug{flex-basis:0%}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
